import { render, staticRenderFns } from "./PlayersTableSettingsModal.vue?vue&type=template&id=6cab06e4&"
import script from "./PlayersTableSettingsModal.vue?vue&type=script&lang=js&"
export * from "./PlayersTableSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./PlayersTableSettingsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports